function setContentHeight() {
  if (jQuery('body').length) {
    const windowHeightSP = jQuery(window).height();

    jQuery('body').css({ height: 'auto' });
    jQuery('html').css({ height: 'auto' });
    jQuery('#main-wrapper').css({ height: 'auto' });
    const bodyHeight = jQuery('body').outerHeight();
    const mainContentSP = jQuery('#main-wrapper').outerHeight();

    if (windowHeightSP > bodyHeight) {
      const newMainContentHeightSP =
        windowHeightSP - bodyHeight + mainContentSP;

      jQuery('#main-wrapper').css('min-height', `${newMainContentHeightSP}px`);
    }
  }
}

jQuery(document).ready(() => {
  setContentHeight();
});

jQuery(window).resize(() => {
  setContentHeight();
});
